/** * @author giovane.oliveira * @71281 - Cadastro de Tipo de ocorrência */
<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-tipoocorrencia') {
            next({ name: 'agro-tipoocorrencia-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-tipoocorrencia') {
            this.$router.push({ name: 'agro-tipoocorrencia-list' });
        }
    },
};
</script>
